
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    export class MbReport_01_Dt_PluDialog extends Serenity.Extensions.GridEditorDialog<MbReport_01_Dt_PluRow> {
        protected getFormKey() { return MbReport_01_Dt_PluForm.formKey; }
        // protected getIdProperty() { return MbReport_01_Dt_PluRow.idProperty; }
        protected getLocalTextPrefix() { return MbReport_01_Dt_PluRow.localTextPrefix; }
        protected getNameProperty() { return MbReport_01_Dt_PluRow.nameProperty; }
        protected getService() { return MbReport_01_Dt_PluService.baseUrl; }
        // protected getDeletePermission() { return MbReport_01_Dt_PluRow.deletePermission; }
        // protected getInsertPermission() { return MbReport_01_Dt_PluRow.insertPermission; }
        // protected getUpdatePermission() { return MbReport_01_Dt_PluRow.updatePermission; }

        protected form = new MbReport_01_Dt_PluForm(this.idPrefix);

    }
}